import templateUrl from 'emun.products/lists/product-list-picker.htm'
import ProductListPickerController from 'emun.products/lists/product-list-picker.controller'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const ProductListPicker = {
    open(options) {
        return modals.open(Object.assign({
            size: 'md',
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: ProductListPickerController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default ProductListPicker;